//@flow
/* eslint-disable prefer-template, no-path-concat, import/unambiguous, import/no-commonjs */
/* eslint-disable camelcase */

const window = require('../../util/window');
const ajax = require('../../util/ajax');
const ImageSource = require('../../source/image_source');
const lercDecoder = require('lerc');
const SphericalMercator = require('sphericalmercator');
const lercUtil = require('./util');
const json2layer = require('./json2layer');
/**
 * A data source containing an image.
 * (See the [Style Specification](https://www.mapbox.com/mapbox-gl-style-spec/#sources-image) for detailed documentation of
 * options.)
 *
 * @interface LercSource
 * @example
 * // add to map
 * map.addSource('some id', {
 *    type: 'imageByTile',
 *    url: 'http://www.baidu.com/',
 *    coordinates: [
 *        [-76.54, 39.18],
 *        [-76.52, 39.18],
 *        [-76.52, 39.17],
 *        [-76.54, 39.17]
 *    ],
 *    tileZoom: 9,  // æå®å è½½åªä¸ªç­çº§çç¦ç
 *    colors: ['#333', '#444', '#555', '#666', '#777', '#888', '#999']
 * });
 *
 * // update
 * var mySource = map.getSource('some id');
 * mySource.setCoordinates([
 *     [-76.54335737228394, 39.18579907229748],
 *     [-76.52803659439087, 39.1838364847587],
 *     [-76.5295386314392, 39.17683392507606],
 *     [-76.54520273208618, 39.17876344106642]
 * ]);
 *
 * map.removeSource('some id');  // remove
 * @see [Add an lerc](https://www.mapbox.com/mapbox-gl-js/example/image-on-a-map/)
 */
class LercSource extends ImageSource {

    constructor(id, options, dispatcher, eventedParent) {
        super(id, options, dispatcher, eventedParent);
        // this.prepare = false;
        this._canvas = {};
        this.paint = lercUtil.handlePaint(options.paint);
    }
    load(options) {
        this.url = options.url;
        this.colors = options.colors;
        // this.tileZoom = options.tileZoom <= options.tileMaxZoom ? options.tileZoom : options.tileMaxZoom;
        this.tileZoom = options.tileMaxZoom;
        this.maxValue = options.maxValue;
        this.minValue = options.minValue;
        this.maskTileUrl = options.maskTileUrl;
        this.maskGeojson = options.maskGeojson;
        this.maskType = options.maskType || 'img'; //æ·¹èç±»åå¾çé¾æ¥2ï¼å¾çbase64 1
        this.headers = options.headers || false;
        this.tileZoom = options.tileZoom || 9;
        this.mask = options.mask || false;
        // this.options = options;

        this.lercLoadState = [];
        this.lercPixels = [];
        // this.canvas = window.document.createElement('canvas');
        // this.gl = this.canvas.getContext('webgl');
        this.xyzArr = [];

        this.xyzArr = this.getBbox();

        // åå§åshaderæ¸²æ
        this._initShader(this.gl);

        this.generateTileGrid();
    }
    onAdd(map) {
        this.load(this.options);
        this.map = map;
        if (this.image) {
            this.setCoordinates(this.coordinates);
        }
    }


    /**
     * éæ°è®¡ç®å¹¶è®¾ç½®å¾ççç»çº¬åº¦èå´
     * è®¡ç®xyzçèå´
     *
     * @returns è¿åxyzçæ°ç»
     *
     * @memberOf LercSource
     */
    getBbox() {
        let bbox;
        if (this.maskType === 'json') {
            const mask = json2layer({data:this.maskGeojson, zoom:this.tileZoom});
            this._maskImage = window.document.createElement('img');
            this._maskImage.crossOrigin = "anonymous";
            this._maskImage.src = mask.url;
            const coordinates = mask.bbox.geometry.coordinates[0];
            bbox = [coordinates[2][0], coordinates[2][1], coordinates[0][0], coordinates[0][1]];
        } else
            bbox = [this.coordinates[2][0], this.coordinates[2][1], this.coordinates[0][0], this.coordinates[0][1]];
        const merc = new SphericalMercator({
            size: 256
        });

        const xyz = merc.xyz(bbox, this.tileZoom);

        const xSize = this.xSize = xyz.maxX - xyz.minX;
        const ySize = this.ySize = xyz.maxY - xyz.minY;


        // è®¾ç½®canvaså¤§å°
        this.canvas = window.document.createElement('canvas');
        this.canvas.width = 256 * (xSize + 1);
        this.canvas.height = 256 * (ySize + 1);
        this.gl = this.canvas.getContext('webgl') || this.canvas.getContext("experimental-webgl");


        const newBboxMax = merc.bbox(xyz.maxX, xyz.minY, this.tileZoom);
        const newBboxMin = merc.bbox(xyz.minX, xyz.maxY, this.tileZoom);
        //è®¾ç½®ç¦çèå´
        this.coordinates = [
            [newBboxMin[0], newBboxMax[3]],
            [newBboxMax[2], newBboxMax[3]],
            [newBboxMax[2], newBboxMin[1]],
            [newBboxMin[0], newBboxMin[1]]
        ];


        if (this.image) {
            this.setCoordinates(this.coordinates);
        }

        const xyzArr = [];

        for (let i = ySize; i >= 0; i--) {
            for (let j = 0; j <= xSize; j++) {
                xyzArr.push([xyz.minX + j, xyz.minY + i, j, i]);
            }
        }

        // const maxX = xyzArr[xyzArr.length - 1][2];
        // const maxY = xyzArr[xyzArr.length - 1][3];
        //console.log((ySize + 1) * (xSize + 1))
        this.lercLoadState.length = (ySize + 1) * (xSize + 1);
        return xyzArr;
    }



    /**
     * ç»åºç½æ ¼åæ 
     *
     * @memberOf LercSource
     */
    generateTileGrid() {
        const gl = this.gl;

        // this.xyzArr.length - 1
        const maxX = this.xSize;
        const maxY = this.ySize;
        const vertices = [];
        // const indices = [];
        const textureCoordinatesItem = [
            // face
            0.0, 0.0,
            0.0, 1.0,
            1.0, 0.0,
            1.0, 1.0
        ];
        let textureCoordinates = [];

        for (let r = 0; r <= maxY; r++) {
            for (let c = 0; c <= maxX; c++) {
                // çæé¡¶ç¹åæ 
                vertices.push(c / (maxX + 1));
                vertices.push(r / (maxY + 1));

                vertices.push(c / (maxX + 1));
                vertices.push((r + 1) / (maxY + 1));

                vertices.push((c + 1) / (maxX + 1));
                vertices.push(r / (maxY + 1));

                vertices.push((c + 1) / (maxX + 1));
                vertices.push((r + 1) / (maxY + 1));
                textureCoordinates = textureCoordinates.concat(textureCoordinatesItem);
            }
        }

        this.vertices = new Float32Array(vertices);

        // ç©éµæ°æ®buffer
        const positionBuffer = gl.createBuffer();
        gl.bindBuffer(gl.ARRAY_BUFFER, positionBuffer);
        gl.bufferData(gl.ARRAY_BUFFER, this.vertices, gl.STATIC_DRAW);

        // é¡¶ç¹
        const aPosiLoc = gl.getAttribLocation(gl.program, 'a_Position');
        gl.vertexAttribPointer(aPosiLoc, 2, gl.FLOAT, false, 0, 0);
        gl.enableVertexAttribArray(aPosiLoc);

        // ä¼ éç»å¸å¤§å°ådemæå¤§å¼
        this._setCanvasSizeToShader(gl);


        // çº¹çé¡¶ç¹
        const cubeVerticesBuffer = gl.createBuffer();
        gl.bindBuffer(gl.ARRAY_BUFFER, cubeVerticesBuffer);
        gl.bufferData(gl.ARRAY_BUFFER, new Float32Array(textureCoordinates),
            gl.STATIC_DRAW);

        const aTextureCoord = gl.getAttribLocation(gl.program, 'a_TextureCoord');
        gl.vertexAttribPointer(aTextureCoord, 2, gl.FLOAT, false, 0, 0);
        gl.enableVertexAttribArray(aTextureCoord);

        // å¾ªç¯çæTileç½æ ¼åæ 

        for (let v = 0; v < (maxX + 1) * (maxY + 1); v++) {
            this.getLercData(v);
        }
    }


    getLercData(i) {
        const index = i;
        const url = this.url.replace('{z}/{x}/{y}', `${this.tileZoom}/${this.xyzArr[index][0]}/${this.xyzArr[index][1]}`);
        const headers = this.headers;
        const requestParameters = {
            url,
            headers,
        };
        ajax.getArrayBuffer(requestParameters, (err, response) => {
            if (err) return this.fire('error', { error: err });

            // è§£ç å½ålercæ°æ®ä¸ºimage
            this._decodeLerc(index, response.data);
        });
    }



    /**
     * è§£ç lercæ°æ®
     *
     * @param {any} index lercçç´¢å¼
     * @param {any} lerc lercåå§æ°æ®
     * @returns è¿åçæçimage
     *
     * @memberOf LercSource
     */
    _decodeLerc(index, lerc) {
        const pixelsObj = lercDecoder.decode(lerc);

        this._generateImageWithWebgl(this.gl, pixelsObj, index);
    }


    /**
     * æ ¹æ®lercæ°æ®ï¼ç¨WebGLçæå¾çå¯¹è±¡
     * @param {any} gl
     * @param {any} pixelObj
     * @param {number} index
     *
     * @returns è¿åimageå¯¹è±¡
     * @memberOf LercSource
     */
    _generateImageWithWebgl(gl, pixelObj, index) {
        // é¡¶ç¹ä¼ å¼
        const HEIGHT = pixelObj.height,
            WIDTH = pixelObj.width;
        // let {canvas,context} = this._canvas[index];
        // let context = this._context[index];

        // ä¹åæ»æ¯é¢ç¹çåå»ºcanvasåcontextï¼è¿æ ·ä¸å¥½
        // ç°å¨å¤ç¨ä¸ä¸ªcanvasï¼æ¯æ¬¡
        // if(canvas || context){
        //     canvas.height = HEIGHT;
        //     canvas.width = WIDTH;
        //     context.clearRect(0,0,WIDTH,HEIGHT);
        // }else{
        const canvas = window.document.createElement('canvas');
        // }
        canvas.height = HEIGHT;
        canvas.width = WIDTH;
        const context = canvas.getContext('2d');
        const structCanvas = this._canvas[index] = {
            canvas:canvas,
            context:context,
        };
        const imageData = context.createImageData(HEIGHT, WIDTH);

        const pixels = imageData.data;

        const decodedPixelBlock = pixelObj.pixels[0];

        for (let i = 0; i < WIDTH * HEIGHT; i++) {
            const j = i + Math.floor(i / WIDTH);
            let rgb = [0, 0, 0, 0];
            if (this.lercVersion === 1)
                rgb = lercUtil.getColor(this.paint, decodedPixelBlock[j]);
            else
                rgb = lercUtil.getColor(this.paint, decodedPixelBlock[i]);

            pixels[i * 4] = rgb[0];
            pixels[i * 4 + 1] = rgb[1];
            pixels[i * 4 + 2] = rgb[2];
            pixels[i * 4 + 3] = 255;
        }
        context.putImageData(imageData, 0, 0);

        context.globalCompositeOperation = "destination-in";
        this.getMask(gl, context, this.maskGeojson, this.maskType, index, structCanvas);
    }
    getMask(gl, context, url, type, index, structCanvas) {
        if (type === 'img') {
            if (this.mask) {
                const imageTexture = window.document.createElement('img');
                imageTexture.src = this.maskTileUrl;
                imageTexture.onload = ()=>{
                    this.drawMaskImage(gl, context, imageTexture, index, structCanvas);
                };
            } else {
                this.drawMaskImage(gl, context, null, index, structCanvas);
            }

        } else if (type === 'json') {
            this.drawMaskImage(gl, context, this._maskImage, index, structCanvas);
        }
    }
    drawMaskImage(gl, context, imageTexture, index, structCanvas) {
        const _this = this;
        const xy = _this.xyzArr;
        if (_this.mask) {
            context.drawImage(imageTexture, 256 * xy[index][2], 256 * xy[index][3], 256, 256, 0, 0, 256, 256);
        }
        //  const img = new Image()
        //  img.src = canvas.toDataURL();

        const texture = gl.createTexture(),
            uSampler = gl.getUniformLocation(gl.program, 'u_Sampler');

        gl.activeTexture(gl.TEXTURE0);
        gl.bindTexture(gl.TEXTURE_2D, texture);

        gl.pixelStorei(gl.UNPACK_FLIP_Y_WEBGL, 1);

        // Set the parameters so we can render any size image.
        gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_WRAP_S, gl.CLAMP_TO_EDGE);
        gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_WRAP_T, gl.CLAMP_TO_EDGE);
        gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_MIN_FILTER, gl.NEAREST);
        gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_MAG_FILTER, gl.NEAREST);

        gl.texImage2D(gl.TEXTURE_2D, 0, gl.RGBA, gl.RGBA, gl.UNSIGNED_BYTE, structCanvas.canvas);
        gl.generateMipmap(gl.TEXTURE_2D);

        // Set the texture unit 0 to the sampler
        gl.uniform1i(uSampler, 0);

        // éåææ
        const textureSharpen = [
            0.0, -1.0, 0.0,
            -1.0, 16.0, -1.0,
            0.0, -1.0, 0.0
        ];

        const kernelLocation = gl.getUniformLocation(gl.program, "u_kernel[0]");
        gl.uniform1fv(kernelLocation, textureSharpen);

        // æ¸²æåºæ¯
        // gl.drawElements(gl.TRIANGLES, 6, gl.UNSIGNED_SHORT, index * 2 * 6);
        gl.drawArrays(gl.TRIANGLE_STRIP, index * 4, 4);

        structCanvas.canvas = undefined;
        structCanvas.context = undefined;
        structCanvas = undefined;
        delete this._canvas[index];
        _this._finishWebGLRender(gl, index);
    }
    /**
     * å®æwebglçç»å¶ï¼å°æ´å¼ å¾çæ¾è¿mapboxglå°å¾ä¸é¢ç»å¶
     *
     * @param {any} gl
     * @param {any} index
     * @returns
     *
     * @memberOf LercSource
     */
    _finishWebGLRender(gl, index) {
        // æ è®°lercæ°æ®å·²ç»å è½½å®æ
        this.lercLoadState[index] = true;
        for (let i = 0; i < this.lercLoadState.length; i++) {
            if (!this.lercLoadState[i]) {
                return;
            }
        }

        // const canvas = window.document.createElement('canvas');
        // canvas.height = gl.canvas.height;
        // canvas.width = gl.canvas.width;

        const imgGL = new window.Image();
        imgGL.src = gl.canvas.toDataURL();


        this.image = imgGL;

        imgGL.onload = () => {
            this._finishLoading();
            this.deleteProgramAndShader();
        };

        // const context = canvas.getContext('2d');

        // const webglTexture = window.document.createElement('img');
        // webglTexture.src = gl.canvas.toDataURL();

        // const woodfill = context.createPattern(webglTexture, "repeat");
        // context.strokeStyle = woodfill;
        // context.fillStyle = woodfill;
        // context.fillRect(0, 0, gl.canvas.width, gl.canvas.height);


        // const imageTexture = window.document.createElement('img');
        // imageTexture.src = "./mask_potato.png";

        // context.globalCompositeOperation = "destination-in";

        // imageTexture.onload = function () {
        //     const woodfill = context.createPattern(imageTexture, "repeat");
        //     context.strokeStyle = woodfill;
        //     context.fillStyle = woodfill;
        //     context.fillRect(0, 0, gl.canvas.width, gl.canvas.height);


        //     const imgGL = new window.Image();
        //     imgGL.src = canvas.toDataURL();

        //     _this.image = imgGL;
        //     _this._finishLoading();
        // };
    }


    /**
     * æ ¹æ®demå¼è·åå¯¹åºé¢è²
     *
     * @param {any} dem æµ·ææ°æ®
     * @param {any} minDem å½åæä½æµ·æ
     * @param {any} step æµ·ææ­¥å¹
     * @param {any} colors é¢è²æ°ç»(äºç»´)
     * @returns é¢è²æ°ç»[r, g, b]
     */
    _getColorByDem(dem, minDem, step, colors) {
        const count = colors.length;

        if (!dem || !minDem || !step || !colors) {
            return [0, 0, 0];
        }

        for (let i = count - 1; i >= 0; i--) {
            if (dem > minDem + step * i) {
                return colors[i];
            }
        }
        return colors[0];
    }



    /**
     * è½¬æ¢é¢è², å°16è¿å¶çè½¬æ¢ä¸ºrgb
     *
     * @param {string} hex åå­è¿å¶é¢è²
     * @returns rgbé¢è²[255,255,255]
     */
    _convertHex(hex) {
        if (hex === undefined) {
            return [0, 0, 0, 0];
        }

        if (hex.indexOf('rgb') > -1) {
            return hex;
        }

        hex = hex.replace('#', '');
        const r = parseInt(hex.substring(0, 2), 16),
            g = parseInt(hex.substring(2, 4), 16),
            b = parseInt(hex.substring(4, 6), 16);
        // return `rgba(${r},${g},${b},255`;
        return [r, g, b];
    }


    // ä¼ éç»å¸å¤§å°, ä¸ºé¡¶ç¹åæ¾å°åæ¢
    _setCanvasSizeToShader(gl) {
        const canvasHeight = gl.getUniformLocation(gl.program, 'canvasHeight'),
            canvasWidth = gl.getUniformLocation(gl.program, 'canvasWidth');

        gl.uniform1f(canvasHeight, gl.canvas.height);
        gl.uniform1f(canvasWidth, gl.canvas.width);
    }


    // åå§åshaderæ¸²æ
    _initShader(gl) {
        const vShader = gl.createShader(gl.VERTEX_SHADER);
        const vSource = this._getVertexSource();
        const fShader = gl.createShader(gl.FRAGMENT_SHADER);
        const fSource = this._getFragmentSource();


        gl.shaderSource(vShader, vSource);
        gl.compileShader(vShader);
        gl.shaderSource(fShader, fSource);
        gl.compileShader(fShader);

        // Create a program object
        const program = gl.createProgram();
        if (!program) {
            return null;
        }

        // Attach the shader objects
        gl.attachShader(program, vShader);
        gl.attachShader(program, fShader);

        // Link the program object
        gl.linkProgram(program);


        // Check the result of linking
        const linked = gl.getProgramParameter(program, gl.LINK_STATUS);
        if (!linked) {
            const error = gl.getProgramInfoLog(program);
            console.log(`Failed to link program: ${error}`);
            gl.deleteProgram(program);
            gl.deleteShader(fShader);
            gl.deleteShader(vShader);
            return null;
        }

        gl.useProgram(program);
        gl.program = program;
        gl.vSource = vSource;
        gl.fSource = fSource;
        return program;
    }



    /**
     * è¿åçåçè²å¨çä»£ç 
     *
     * @returns fragment source
     *
     * @memberOf LercSource
     */
    _getFragmentSource() {
        const fSource = `
            precision mediump float;

            // çº¹ç
            uniform sampler2D u_Sampler;
            varying vec2 v_TextureCoord;
            uniform float u_kernel[9];

            void main(){
                vec2 onePixel = vec2(1.0, 1.0) / vec2(256.0, 256.0);
                vec4 colorSum =
                    texture2D(u_Sampler, v_TextureCoord + onePixel * vec2(-1.0, -1.0)) * u_kernel[0] +
                    texture2D(u_Sampler, v_TextureCoord + onePixel * vec2( 0.0, -1.0)) * u_kernel[1] +
                    texture2D(u_Sampler, v_TextureCoord + onePixel * vec2( 1.0, -1.0)) * u_kernel[2] +
                    texture2D(u_Sampler, v_TextureCoord + onePixel * vec2(-1.0,  0.0)) * u_kernel[3] +
                    texture2D(u_Sampler, v_TextureCoord + onePixel * vec2( 0.0,  0.0)) * u_kernel[4] +
                    texture2D(u_Sampler, v_TextureCoord + onePixel * vec2( 1.0,  0.0)) * u_kernel[5] +
                    texture2D(u_Sampler, v_TextureCoord + onePixel * vec2(-1.0,  1.0)) * u_kernel[6] +
                    texture2D(u_Sampler, v_TextureCoord + onePixel * vec2( 0.0,  1.0)) * u_kernel[7] +
                    texture2D(u_Sampler, v_TextureCoord + onePixel * vec2( 1.0,  1.0)) * u_kernel[8] ;
                float kernelWeight =
                    u_kernel[0] +
                    u_kernel[1] +
                    u_kernel[2] +
                    u_kernel[3] +
                    u_kernel[4] +
                    u_kernel[5] +
                    u_kernel[6] +
                    u_kernel[7] +
                    u_kernel[8] ;

                float alph = 1.0;
                if (kernelWeight <= 0.0) {
                   kernelWeight = 1.0;
                }

                if((colorSum / kernelWeight).r <= 0.1
                    && (colorSum / kernelWeight).g <= 0.1
                    && (colorSum / kernelWeight).b <= 0.1){
                    alph = 0.0;
                }

                gl_FragColor = vec4((colorSum / kernelWeight).rgb, alph);

                // gl_FragColor = texture2D(u_Sampler, v_TextureCoord);
            }
        `;
        return fSource;
    }


    /**
     * è¿åé¡¶ç¹çè²å¨çä»£ç 
     *
     * @returns vertex source
     *
     * @memberOf LercSource
     */
    _getVertexSource() {
        const vSource = `
            attribute vec2 a_Position;

            uniform float canvasHeight;
            uniform float canvasWidth;

            uniform float canvasDemMax;
            uniform float canvasDemMin;

            // ä¼ éçº¹ç
            attribute vec2 a_TextureCoord;
            varying vec2 v_TextureCoord;


            void main(){
                float positionWidth = a_Position.x * 2.0 - 1.0;
                float positionHeight = a_Position.y * 2.0 - 1.0;

                gl_Position = vec4(positionWidth, positionHeight, 0.0, 1.0);
                // gl_PointSize = 10.0;
                // ä¼ éçº¹ç
                v_TextureCoord = a_TextureCoord;
            }
        `;
        return vSource;
    }


    /**
     * è®¾ç½®è·åç¦ççæå¤§èå´
     *
     * @param {any} coordinates
     * @returns map
     *
     * @memberOf LercSource
     */
    setBounds(coordinates) {
        this.options.coordinates = coordinates;
        this.options.tileZoom = parseInt(this.map.getZoom());

        this.load(this.options);

        return this;
    }



    serialize() {
        return {
            type: 'lercImage',
            url: this.url,
            coordinates: this.coordinates,
            tileZoom: this.tileZoom,
            colors: this.colors
        };
    }
    deleteProgramAndShader() {
        this.gl.deleteProgram(this.gl.program);
        this.gl.deleteShader(this.gl.fShader);
        this.gl.deleteShader(this.gl.vShader);
        const WEBGL_lose_context =  this.gl.getExtension('WEBGL_lose_context');
        if (WEBGL_lose_context) {
            WEBGL_lose_context.loseContext();
        }
    }

}

module.exports = LercSource;
